import type { AsyncFlowWithData } from './utilities';
import type { Bff } from 'core/services';

export const ORDER_PAYMENT_VIEWS = {
  GENERIC: 'order.payment.generic',
  BOLETO: 'order.payment.boleto.cash',
  BOLETO_INSTALLMENTS: 'order.payment.installments',
  CREDIT_CARD_CANCELED: 'order.credit.card.canceled',
  CREDIT_CARD_PROCESS: 'order.credit.process',
  CREDIT_CARD_PROCESSING: 'order.credit.processing',
  OTHER: 'order.link.payment',
  PIX: 'order.payment.pix',
};

type OrderBase = {
  installments?: number;
};

type OrderData = OrderBase & {
  code: string;
  deliveryDate: string;
  payments: PaymentDetail[];
  shippingModel: ShippingModelAddress;
  paymentAmount: string;
  paymentMethod: string;
  status: `${Bff.OrderResponse['data']['tracking'][number]['status']}`;
};

type ShippingModelAddress = {
  fullAddress: string;
  shippingModelCode: number;
};

type PaymentDetail = OrderBase & {
  amountNum: number;
  code: string;
  dueDate: string;
  link: string;
  name: string;
  type: unknown;
};

export type CreateOrder = Partial<OrderBase> & {
  paymentCode?: string;
  paymentDetails?: PaymentDetails;
  sessionID?: string;
};

export type Order = AsyncFlowWithData<OrderData> & {
  view: ORDER_PAYMENT_VIEWS;
};

export type ShippingModelBusiness = {
  shippingModelType: string;
  distributionCenterDefaultCode?: number;
};
